import React from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const proofPoints = [
  {
    icon: 'ri-tools-fill',
    text: 'Practical guidance for project teams delivering NSW built environment projects',
  },
  {
    icon: 'ri-shield-check-line',
    text: 'Supports culturally safe engagement and ICIP-aware practice',
  },
  {
    icon: 'ri-focus-3-line',
    text: 'Builds genuine cultural capability for meaningful, Country-centred project delivery',
  },
];

export default function ImplementationFramework() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <section className="py-24 lg:py-32 bg-[#0E0503] text-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
        <div
          ref={sectionRef as React.RefObject<HTMLDivElement>}
          className={`transition-all duration-700 ease-out ${
            sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Heading */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight mb-4">
            Ready to build Country-led capability across your projects
          </h2>

          {/* Subheading */}
          <p className="text-[#E8C580] text-lg mb-12 leading-relaxed">
            Self-paced online course with 12-month access. Aligned with Better Placed and Connecting with Country.
          </p>

          {/* Proof Points */}
          <ul className="flex flex-col gap-4 mb-12 text-left max-w-xl mx-auto">
            {proofPoints.map((point, i) => (
              <li
                key={i}
                className={`flex items-start gap-5 transition-all duration-700 ease-out ${
                  sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
                }`}
                style={{ transitionDelay: `${(i + 1) * 120}ms` }}
              >
                <span className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-full bg-[#BA3D03]/20 text-[#E8C580] pt-0.5">
                  <i className={`${point.icon} text-base`}></i>
                </span>
                <span className="text-white font-medium text-base leading-relaxed">{point.text}</span>
              </li>
            ))}
          </ul>

          {/* Buttons */}
          <div
            className={`flex flex-col sm:flex-row gap-4 justify-center transition-all duration-700 ease-out ${
              sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '480ms' }}
          >
            <a
              href="#contact-section"
              className="w-full sm:w-auto whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#BA3D03] hover:bg-[#a33503] text-white font-semibold rounded-md transition-all duration-200 cursor-pointer text-base"
            >
              <i className="ri-building-line"></i>
              Request Company Pricing
            </a>
          </div>

          {/* Fine print */}
          <p
            className={`mt-6 text-white/40 text-sm transition-all duration-700 ease-out ${
              sectionVisible ? 'opacity-100' : 'opacity-0'
            }`}
            style={{ transitionDelay: '600ms' }}
          >
            We'll respond by email with pricing, next steps, and access details.
          </p>
        </div>
      </div>
    </section>
  );
}
